import React, { Component } from "react";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import {
  profile,
  alert,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  toFixed,
  total,
  Status,
  BtnIcon,
  float,
  DatePicker,
  project,
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";
import Dropdown from "react-bootstrap/Dropdown";

import {
  report_petty_cash_report_table,
  report_petty_cash_report_full,
} from "../../components/Report.js";
import { stripJuristic } from "../../components/text-sanitize.js";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import Resizer from "react-image-file-resizer";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
const status = {
  pending: {
    name: "รอตรวจสอบ",
    style: "text-warning",
    role: "super_user,admin,accounting",
  },
  fix: {
    name: "แก้ไข",
    style: "text-danger",
    role: "super_user,admin,accounting",
  },
  fixed: {
    name: "แก้ไขแล้ว",
    style: "text-info",
    role: "super_user,admin,accounting,finance,project_manager,center_manager",
  },
  approved: {
    name: "อนุมัติ",
    style: "text-success",
    role: "super_user,admin,accounting",
  },
};
export default class PettyCashReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      modal_create: false,
      modal_update: false,
      modal_export: false,
      modal_expenses: false,
      modal_create_update_expenses: false,
      expenses_no: -1,
      expenses_index: -1,
      expenses_name: "",

      filter_search: "",
      filter_date: format_date(new Date(), "yyyy-mm", "en"),

      data: [],
      data_petty_cash: [],
      data_expense_type: [],

      slip_image: "",
      time_index: -1,
      cash_index: -1,
      image_index: -1,
      select_image: "",
      slip_index: -1,
      index: -1,

      filter_month: format_date(new Date(), "yyyy-mm", "en"),

      type_export: "",

      // -----------------------------------
      tab_menu: "สร้าง",
      type: "",

      year: null,
      month: null,
      _status: "",

      prev_month_limit_withdraw: "",
      prev_month_previuse_balance: "",
      prev_expenses_type_label_1: "",
      prev_expenses_type_label_2: "",
      prev_expenses_type_label_3: "",
      prev_expenses_type_label_4: "",
      prev_expenses_type_label_5: "",
      prev_expenses_type_label_6: "",
      prev_expenses_type_center_1: "",
      prev_expenses_type_center_2: "",
      prev_expenses_type_center_3: "",
      prev_expenses_type_center_4: "",
      prev_expenses_type_center_5: "",
      prev_expenses_type_center_6: "",

      index_data_petty_cash: -1,
      index_expenses: -1,
      expenses_type_center: "",
    };

    this.inputRefs = [];
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
    this.GetExpenseCenter();
  }
  Get = async (page = 1) => {
    const { filter_search, year, month } = this.state;
    let data, count;
    loading(true);
    let body = {
      page: page,
      data_search: filter_search,
    };
    let result = await GET("api/admin/petty-cash-report/list", body);
    if (result?.status) {
      data = result.data;
      count = result.count;
      data = data?.reduce((acc, item) => {
        const key = `${item.year}-${String(item.month).padStart(2, "0")}`;

        if (!acc[key]) acc[key] = [];
        acc[key].push(item);

        return acc;
      }, {});

      if (data) {
        data = Object.entries(data).map(([key, value]) => ({
          yearMonth: key,
          year: Number(key.split("-")[0]),
          month: Number(key.split("-")[1]),
          items: value.sort((a, b) => a.time - b.time),
          show: false,
        }));
      }

      // เช็คว่า อันแรกสุด เป็น pemding ไหม ถ้นเป็น ดึงข้อมูล ล่าสุดมา
      let _data = result.data?.filter((e) => e.status !== "cancel");
      if (_data && _data[0] && _data[0].status === "pending") {
        let result_detail = await Promise.all(
          _data
            .filter((e) => e.year === data[0].year && e.month === data[0].month)
            .filter((e) => e.status !== "cancel")
            .map(async (e) => {
              const detail = await GET("api/admin/petty-cash-report/list", {
                petty_cash_id: e.petty_cash_id,
              });
              return detail.data;
            }),
        );
        // จัดการเดือนปัจจุบัน
        this.setState({
          data_petty_cash: result_detail.map((e) => ({
            ...e,
            expenses_type_label_6: typeof e.expenses_type_label_6 === "string" ? e.expenses_type_label_6 : "",
            list_cash_spend:
              e.list_cash_spend.map((l) => ({
                ...l,
                date: l.date ? format_date(l.date, "yyyy-mm-dd", "en") : "",
              })) || [],
          })),
          year: result_detail[0].year,
          month: result_detail[0].month,
        });
      } else if (_data && _data[0] && _data[0].status === "approved") {
        _data = _data?.reduce((acc, item) => {
          const key = `${item.year}-${String(item.month).padStart(2, "0")}`;

          if (!acc[key]) acc[key] = [];
          acc[key].push(item);

          return acc;
        }, {});

        _data = Object.entries(_data).map(([key, value]) => ({
          yearMonth: key,
          year: Number(key.split("-")[0]),
          month: Number(key.split("-")[1]),
          items: value.sort((a, b) => a.time - b.time),
          show: false,
        }));
        const prev = _data[0].items
          .filter((e) => e.status !== "cancel")
          .sort((a, b) => b.time - a.time)[0];
        let result_detail = await GET("api/admin/petty-cash-report/list", {
          petty_cash_id: prev.petty_cash_id,
        });
        result_detail = result_detail.data;

        this.setState({
          year: Number(
            format_date(
              new Date(result_detail.year, result_detail.month),
              "yyyy",
              "en",
            ),
          ),
          month: Number(
            format_date(
              new Date(result_detail.year, result_detail.month),
              "mm",
              "en",
            ),
          ),
          prev_expenses_type_label_1: result_detail.expenses_type_label_1 || "",
          prev_expenses_type_label_2: result_detail.expenses_type_label_2 || "",
          prev_expenses_type_label_3: result_detail.expenses_type_label_3 || "",
          prev_expenses_type_label_4: result_detail.expenses_type_label_4 || "",
          prev_expenses_type_label_5: result_detail.expenses_type_label_5 || "",
          prev_expenses_type_label_6: result_detail.expenses_type_label_6 || "",
          prev_expenses_type_center_1:
            result_detail.expenses_type_center_1 || "",
          prev_expenses_type_center_2:
            result_detail.expenses_type_center_2 || "",
          prev_expenses_type_center_3:
            result_detail.expenses_type_center_3 || "",
          prev_expenses_type_center_4:
            result_detail.expenses_type_center_4 || "",
          prev_expenses_type_center_5:
            result_detail.expenses_type_center_5 || "",
          prev_expenses_type_center_6:
            result_detail.expenses_type_center_6 || "",
          prev_month_limit_withdraw: result_detail.limit_withdraw?.amount || "",
          prev_month_previuse_balance:
            Number(result_detail.limit_withdraw.amount) -
              total(
                result_detail?.list_cash_spend?.map((e) =>
                  total(e.amount, "amount"),
                ),
              ) || "",
        });
      } else {
        this.setState({
          year: year || Number(format_date(new Date(), "yyyy", "en")),
          month: month || Number(format_date(new Date(), "mm", "en")),
        });
      }
    }

    this.setState({ data, count });
    loading(false);
  };
  GetByID = async (year, month) => {
    const { data } = this.state;
    loading(true);
    let result_detail = await Promise.all(
      data
        .find((e) => e.year === year && e.month === month)
        .items.map(async (e) => {
          const detail = await GET("api/admin/petty-cash-report/list", {
            petty_cash_id: e.petty_cash_id,
          });
          return detail.data;
        }),
    );
    // จัดการเดือนปัจจุบัน
    this.setState({
      data_petty_cash: result_detail.map((e) => ({
        ...e,
            expenses_type_label_6: typeof e.expenses_type_label_6 === "string" ? e.expenses_type_label_6 : "",
        list_cash_spend:
          e.list_cash_spend.map((l) => ({
            ...l,
            date: l.date ? format_date(l.date, "yyyy-mm-dd", "en") : "",
          })) || [],
      })),
      year: result_detail[0].year,
      month: result_detail[0].month,
      _status: result_detail[0].status,
    });
    loading(false);
  };
  GetExpenseCenter = async () => {
    loading(true);
    let result = await GET("api/admin/expense-types-centers/list", null);
    if (result?.status) {
      this.setState({
        data_expense_type: result.data
          ?.filter((e) => e.is_active)
          .map((e) => ({
            value: e.expense_type_id,
            label: e.expense_type_name,
          })),
      });
    }
    loading(false);
  };
  CreateUpdate = async (_status) => {
    const { data_petty_cash } = this.state;

    // if(data_petty_cash.some(item=> (
    //                         Number(item.limit_withdraw.amount) -
    //                           total(
    //                             item?.list_cash_spend?.map((e) =>
    //                               total(e.amount, "amount")
    //                             )
    //                           )
    //                        < 0))){
    //   alert("","warning","แจ้งเตือน","ยอดเงินสดย่อยคงเหลือติดลบ กรุณาตรวจสอบใหม่อีกครั้ง");
    //   return;
    //                        }
    loading(true);
    let status = [];
    for (let item of data_petty_cash) {
      let list_cash_spend = item.list_cash_spend;
      let result_image = await Promise.all(
        list_cash_spend.map((e) =>
          e.image_slip.length !== 0
            ? POST("api/admin/upload-data/image", { image_slip: e.image_slip })
            : { data: [] },
        ),
      );
      list_cash_spend = list_cash_spend.map((e, i) => ({
        ...e,
        image_slip: result_image[i].data,
      }));
      let body = {
        year: item.year,
        month: item.month,
        time: item.time,
        status: item.status === "cancel" ? "cancel" : (_status || "pending"),
        limit_withdraw: item.limit_withdraw,
        previuse_balance: item.previuse_balance,
        cash_withdraw: item.cash_withdraw,
        list_cash_spend: list_cash_spend,
        expenses_type_label_1: item.expenses_type_label_1,
        expenses_type_label_2: item.expenses_type_label_2,
        expenses_type_label_3: item.expenses_type_label_3,
        expenses_type_label_4: item.expenses_type_label_4,
        expenses_type_label_5: item.expenses_type_label_5,
        expenses_type_label_6: item.expenses_type_label_6,
        expenses_type_center_1: item.expenses_type_center_1,
        expenses_type_center_2: item.expenses_type_center_2,
        expenses_type_center_3: item.expenses_type_center_3,
        expenses_type_center_4: item.expenses_type_center_4,
        expenses_type_center_5: item.expenses_type_center_5,
        expenses_type_center_6: item.expenses_type_center_6,
      };
      let result = !item.petty_cash_id
        ? await POST("api/admin/petty-cash-report/create", body)
        : await PUT(
            "api/admin/petty-cash-report/update/" + item.petty_cash_id,
            body,
          );
      status.push(result?.status);
    }
    if (status.every((e) => e)) {
      alert("#", "success");
    }
    loading(false);
  };
  Delete = async (petty_cash_id) => {
    Swal.fire({
      title: "ยืนยัน",
      text: `ยืนยันการลบข้อมูลนี้หรือไม่?`,
      icon: "info",
      input: "textarea",
      inputPlaceholder: "กรอกเหตุผล...",
      showCancelButton: true,
      confirmButtonText: "ลบข้อมูล",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#198754",
      cancelButtonColor: "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        const remark = re.value;
        loading(true);
        let body = { status: "cancel", remark };
        let result = await PUT(
          "api/admin/petty-cash-report/update/" + petty_cash_id,
          body,
        );
        if (result?.status) {
          alert("#", "success");
        }
        loading(false);
      }
    });
  };
  calculatePrice = async () => {
    const { data_petty_cash } = this.state;
    let _total = null;
    for (let item of data_petty_cash) {
      if (_total !== null) {
        item.previuse_balance.amount = _total;
      }
      _total =
        Number(item.limit_withdraw.amount) -
        total(item?.list_cash_spend?.map((e) => total(e.amount, "amount")));
      item.cash_withdraw.amount =
        Number(item.limit_withdraw.amount) -
        Number(item.previuse_balance.amount);
    }
    this.setState({ data_petty_cash });
  };
  cal = (id, cash_id) => {
    const { data_petty_cash } = this.state;
    let amount = 0;
    data_petty_cash.forEach((item, index) => {
      if (index === id) {
        item.list_cash_spend?.forEach((cash, cash_index) => {
          if (cash_index <= cash_id) {
            amount += total(cash.amount, "amount");
          }
        });
      }
    });
    return Number(data_petty_cash[id]?.limit_withdraw?.amount) - amount;
  };
  calTotal = (id, ex_id) => {
    const { data_petty_cash } = this.state;
    let amount = 0;
    data_petty_cash.forEach((item, index) => {
      if (index === id) {
        item.list_cash_spend?.forEach((cash, cash_index) => {
          amount += Number(cash.amount[ex_id]?.amount || 0);
        });
      }
    });
    return amount;
  };

  exportExcel = async () => {
  const { data_petty_cash, year, month } = this.state;
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Summary");

  let rowIndex = 1;

  // ==========================================
  // HELPER FUNCTIONS (ฟังก์ชันตัวช่วยเพื่อลดโค้ดซ้ำ)
  // ==========================================

  // ตัวช่วยดึงประเภทค่าใช้จ่าย (แบบไดนามิก ไม่ต้องเขียน if 6 ตัว)
  const getDynamicLabels = (item) => 
    [1, 2, 3, 4, 5, 6].map((i) => item[`expenses_type_label_${i}`]).filter(Boolean);

  // ตัวช่วยตั้งค่า Style ให้ Cell
  const applyStyle = (cell, { bg, fontColor, bold, align, numFmt, border }) => {
    if (bg) cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg.startsWith("FF") ? bg : `FF${bg}` } };
    if (fontColor || bold) cell.font = { bold, color: { argb: fontColor }, size: 10 };
    if (align) cell.alignment = { horizontal: align, vertical: "middle" };
    if (numFmt) cell.numFmt = numFmt;
    if (border) cell.border = { top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" } };
  };

  // ตัวช่วยสร้าง Header หลัก
  const mainHeader = (text, bg = "198754", fontColor = "FFFFFF", align = "left") => {
    ws.mergeCells(rowIndex, 1, rowIndex, 15);
    const cell = ws.getRow(rowIndex).getCell(1);
    cell.value = text;
    applyStyle(cell, { bg, fontColor, bold: true, align });
    ws.getRow(rowIndex).height = 25;
    rowIndex++;
  };

  // ==========================================
  // ROW GENERATORS (ฟังก์ชันสร้างแต่ละแถว)
  // ==========================================

  const titleRow = (item) => {
    ws.mergeCells(rowIndex, 1, rowIndex, 3);
    const row = ws.getRow(rowIndex);
    row.getCell(1).value = `${item.project_name || ""} ${format_date(new Date(item.year, item.month - 1), "mmmm yyyy", "th")} (ครั้งที่ ${item.time})`;
    row.height = 25;
    rowIndex++;
  };

  const sectionHeader1 = (item, labels) => {
  // แก้ไข: ให้จำนวนคอลัมน์ของ "ประเภทการจ่าย" เท่ากับจำนวน label + 1 เสมอ
  // (ถ้า labels ว่าง จะได้ 0 + 1 = 1 ช่องเสมอ)
  const typeColsCount = labels.length + 1; 
  const endTypeCol = 5 + typeColsCount;

  ws.mergeCells(rowIndex, 1, rowIndex, 3); // A–C (ข้อมูลการใช้จ่ายเงินสดย่อย)
  ws.mergeCells(rowIndex, 4, rowIndex, 5); // D–E (ใบสำคัญ)
  
  // Merge "ประเภทการจ่าย" เฉพาะกรณีที่ใช้พื้นที่มากกว่า 1 ช่อง (คอลัมน์จบ > 6)
  if (endTypeCol > 6) {
    ws.mergeCells(rowIndex, 6, rowIndex, endTypeCol); 
  }

  // Merge ส่วนของ หมายเหตุ
  ws.mergeCells(rowIndex, endTypeCol + 3, rowIndex, endTypeCol + 5); 

  const row = ws.getRow(rowIndex);
  row.getCell(1).value = "ข้อมูลการใช้จ่ายเงินสดย่อย";
  row.getCell(4).value = "ใบสำคัญ";

  // ใส่คำว่า "ประเภทการจ่าย" ได้เลย
  row.getCell(6).value = "ประเภทการจ่าย";

  row.getCell(endTypeCol + 1).value = "เงินสดย่อย";
  row.getCell(endTypeCol + 2).value = " "; 
  row.getCell(endTypeCol + 3).value = "หมายเหตุ";

  row.height = 25;

  // วนลูป Style ไปจนสุดช่องหมายเหตุ (endTypeCol + 5)
  for (let col = 1; col <= endTypeCol + 5; col++) {
    applyStyle(row.getCell(col), { 
      bg: "FF198754", 
      fontColor: "FFFFFFFF", 
      bold: true, 
      align: "center", 
      border: true 
    });
  }
  
  rowIndex++;
};

  const sectionHeader2 = (item, labels) => {
    ws.mergeCells(rowIndex, 1, rowIndex, 3);
    const row = ws.getRow(rowIndex);
    
    // รวม Array หัวตารางเข้าด้วยกัน
    row.values = [
      "ลำดับ", "วันที่", "รายการค่าใช้จ่าย", "เล่มที่", "เลขที่",
      ...labels, // เอา label ไดนามิกมาต่อ
      "ยอดรวม", "คงเหลือ", "สถานะ", "ใบเสร็จ", "สำเนาบัตร","รูปสลิป"
    ];

    row.height = 25;
    row.eachCell((cell) => applyStyle(cell, { bg: "FF198754", fontColor: "FFFFFFFF", bold: true, align: "center" }));
    rowIndex++;
  };

  const tableRow = (item, index, labels) => {
    ws.mergeCells(rowIndex, 1, rowIndex, 3);
    const row = ws.getRow(rowIndex);

    // ดึงจำนวนเงินตามจำนวน Label ที่มี
    const amounts = labels.map((_, i) => Number(item?.amount?.[i]?.amount || 0));

    row.values = [
      index === "" ? "" : index + 1,
      format_date(item.date),
      item.name,
      item.volumn_no,
      item.no,
      ...amounts,
      Number(total(item.amount, "amount")),
      Number(typeof item.amount === "object" ? this.cal(index, index) || 0 : item.amount),
      status[item.status]?.name || "",
      item.receipt ? "มี" : "ไม่มี",
      item.copy_id_card ? "มี" : "ไม่มี"
    ];

    row.height = 25;

    // จัดตำแหน่งตัวเลขชิดขวา และจัดฟอร์แมตเงิน
    row.eachCell((cell, colNumber) => {
      cell.alignment = { vertical: "middle" };
      // คอลัมน์ลำดับ และคอลัมน์ที่เป็นตัวเลข (เริ่มตั้งแต่คอลัมน์ที่ 6 จนถึง ยอดคงเหลือ)
      if (colNumber === 1 || (colNumber >= 6 && colNumber <= 7 + labels.length)) {
        applyStyle(cell, { align: "right" });
        if (colNumber > 1) applyStyle(cell, { numFmt: "#,##0.00" }); // ข้ามฟอร์แมตเงินในช่องลำดับ
      }
    });

    rowIndex++;
  };

  const finalRow = (label, value, labelsLen) => {
    ws.mergeCells(rowIndex, 1, rowIndex, 3);
    const row = ws.getRow(rowIndex);

    const totalColIndex = 5 + labelsLen + 1; // ตำแหน่งคอลัมน์ "ยอดรวม" อิงตามจำนวนประเภทค่าใช้จ่าย
    row.getCell(totalColIndex - 1).value = label; 
    row.getCell(totalColIndex).value = Number(value);

    row.height = 25;
    applyStyle(row.getCell(totalColIndex - 1), { bold: true, align: "right" });
    applyStyle(row.getCell(totalColIndex), { bold: true, align: "right", numFmt: "#,##0.00" });

    rowIndex++;
  };

  // ==========================================
  // MAIN EXECUTION (ส่วนประมวลผลหลัก)
  // ==========================================

  mainHeader(`${project?.project_name || "ผู้ดูแลระบบ"}`, null, "000000", "center");
  mainHeader(`รายงานเงินสดย่อย`, null, "000000", "center");
  mainHeader(`สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`, null, "000000", "center");

  const validData = data_petty_cash
    ?.sort((a, b) => (a.status?.localeCompare(b.status) !== 0 ? a.status?.localeCompare(b.status) : a.time - b.time))
    .filter((e) => e.status !== "cancel") || [];

  validData.forEach((item) => {
    const labels = getDynamicLabels(item); // ดึงประเภทการจ่ายแบบ Array ครั้งเดียวใช้ได้ทุกตาราง

    titleRow(item);
    sectionHeader1(item, labels);
    sectionHeader2(item, labels);
    
    tableRow(item.limit_withdraw, "", labels);
    tableRow(item.previuse_balance, "", labels);
    tableRow(item.cash_withdraw, "", labels);
    
    item.list_cash_spend?.forEach((cash, cash_index) => {
      tableRow(cash, cash_index, labels);
    });

    const sumExpenses = total(item?.list_cash_spend?.map((d) => total(d.amount, "amount")));
    finalRow("ค่าใช้จ่ายรวมทั้งสิ้น", sumExpenses, labels.length);
    finalRow("ยอดเงินสดย่อยคงเหลือทั้งสิ้น", Number(item.limit_withdraw.amount) - sumExpenses, labels.length);
  });

  // กำหนด Font size เป็น 10 ให้ทั้ง Worksheet
  ws.eachRow({ includeEmpty: true }, (row) => {
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { ...(cell.font || {}), size: 10 };
    });
  });

  // ==========================================
  // EXPORT
  // ==========================================
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `รายการค้างชำระ.xlsx`);
};

  imageUrlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };
  printPDF = async (type) => {
    const { data_petty_cash, year, month } = this.state;
    if (type === "table") {
      report_petty_cash_report_table(
        data_petty_cash.filter((e) => e.status !== "cancel"),
        year,
        month,
      );
    } else {
      let _data_petty_cash = JSON.parse(
        JSON.stringify(data_petty_cash.filter((e) => e.status !== "cancel")),
      );

      for (const petty of _data_petty_cash) {
        if (!Array.isArray(petty.list_cash_spend)) continue;

        for (const item of petty.list_cash_spend) {
          if (!Array.isArray(item.image_slip)) continue;

          for (let i = 0; i < item.image_slip.length; i++) {
            const url = item.image_slip[i];
            if (!url) continue;

            // แปลง URL → Base64 แล้วเขียนกลับ
            item.image_slip[i] = await this.imageUrlToBase64(url);
          }
        }
      }

      report_petty_cash_report_full(_data_petty_cash, year, month);
    }
  };
  handleEnterAuto = (e, rowIndex) => {
    if (e.key !== "Enter") return;

    if (
      e.target.tagName !== "INPUT" ||
      e.target.type !== "text" ||
      !e.target.classList.contains("enter")
    )
      return;

    e.preventDefault();

    const inputs = Array.from(
      document.querySelectorAll('input[type="text"].enter:not([disabled])'),
    );

    const currentIndex = inputs.indexOf(e.target);

    // ✅ มี input ถัดไป → focus ปกติ
    if (inputs[currentIndex + 1]) {
      inputs[currentIndex + 1].focus();
      return;
    }

    // ❗ ไม่มี → เพิ่ม row ใหม่
    const data_petty_cash = [...this.state.data_petty_cash];

    data_petty_cash[rowIndex].list_cash_spend.push({
      date: format_date(new Date(), "yyyy-mm-yy", "en"),
      name: "",
      volumn_no: "",
      no: "",
      amount: [
        { name: data_petty_cash[rowIndex]?.expenses_type_label_1, amount: "" },
        { name: data_petty_cash[rowIndex]?.expenses_type_label_2, amount: "" },
        { name: data_petty_cash[rowIndex]?.expenses_type_label_3, amount: "" },
        { name: data_petty_cash[rowIndex]?.expenses_type_label_4, amount: "" },
        { name: data_petty_cash[rowIndex]?.expenses_type_label_5, amount: "" },
        { name: data_petty_cash[rowIndex]?.expenses_type_label_6, amount: "" },
      ],
      status: "pending",
      receipt: false,
      copy_id_card: false,
      image_slip: [],
    });

    this.setState({ data_petty_cash }, () => {
      // ⏱ รอ render แล้วค่อย focus ช่องแรกของ row ใหม่
      setTimeout(() => {
        const newInputs = document.querySelectorAll(
          'input[type="text"].enter:not([disabled])',
        );
        newInputs[newInputs.length - 1]?.focus();
      }, 0);
    });
  };
  render() {
    const {
      modal_detail,
      modal_create,
      modal_update,
      modal_export,
      modal_expenses,
      modal_create_update_expenses,
      expenses_index,
      expenses_no,
      expenses_name,

      filter_date,
      filter_search,

      data,
      data_petty_cash,
      data_expense_type,

      select_image,
      slip_index,
      index,

      filter_month,

      type_export,
      // ...
      tab_menu,
      type,

      year,
      month,
      _status,

      slip_image,
      time_index,
      cash_index,
      image_index,

      prev_month_limit_withdraw,
      prev_month_previuse_balance,
      prev_expenses_type_label_1,
      prev_expenses_type_label_2,
      prev_expenses_type_label_3,
      prev_expenses_type_label_4,
      prev_expenses_type_label_5,
      prev_expenses_type_label_6,
      prev_expenses_type_center_1,
      prev_expenses_type_center_2,
      prev_expenses_type_center_3,
      prev_expenses_type_center_4,
      prev_expenses_type_center_5,
      prev_expenses_type_center_6,

      index_data_petty_cash,
      index_expenses,
      expenses_type_center,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 position-relative">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายงานเงินสดย่อย"
        />

        <div className="body px-3 pb-3 pt-0" style={{ marginBottom: 200 }}>
          {/* HEADER */}
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <h4 className="fw-bold mb-3 me-3">รายงานเงินสดย่อย {type}</h4>
            </div>
            {type !== "" ? (
              <button
                className="rounded-4 btn btn-outline-success px-3 mb-0"
                onClick={() =>
                  this.setState(
                    {
                      tab_menu: "สร้าง",
                      type: "",
                      data_petty_cash: [],
                      year: null,
                      month: null,
                    },
                    () => {
                      this.Get();
                    },
                  )
                }
              >
                ย้อนกลับ
              </button>
            ) : (
              <div className="d-flex mb-3">
                <div
                  className="border rounded-4 border-success mb-2 me-2"
                  style={{ padding: 1 }}
                >
                  <button
                    className={`rounded-4 btn ${
                      tab_menu === "สร้าง"
                        ? "btn-success"
                        : "btn-outline-success border-0"
                    } px-3 mb-0`}
                    onClick={() =>
                      this.setState(
                        {
                          tab_menu: "สร้าง",
                          tab: "ยอดที่ยกมา",
                        },
                        () => {
                          this.Get();
                        },
                      )
                    }
                  >
                    สร้าง
                  </button>
                  <button
                    className={`rounded-4 btn ${
                      tab_menu === "รายการ"
                        ? "btn-success"
                        : "btn-outline-success border-0"
                    } px-3 mb-0`}
                    onClick={() =>
                      this.setState({
                        tab_menu: "รายการ",
                        prev_month_limit_withdraw: "",
                        prev_month_previuse_balance: "",
                      })
                    }
                  >
                    รายการ
                  </button>
                </div>
              </div>
            )}
          </div>
          <hr />
          {/* สร้าง */}
          {tab_menu === "สร้าง" && (
            <div>
              {/* HEADER และ ปุ่มสร้าง */}
              <div className="d-flex align-items-center flex-wrap mb-2">
                <h4 className="fw-bold me-3">
                  {year
                    ? format_date(new Date(year, month - 1), "mmmm yyyy", "th")
                    : ""}
                </h4>
                {year &&
                  data.every(e=> (e.items).every(i => i.status === "cancel")) && (
                    <input
                      type="month"
                      className="form-control wpx-200 me-3 mb-3"
                      onChange={(e) => {
                        this.setState(
                          {
                            year: e.target.value
                              ? Number(e.target.value.split("-")[0])
                              : null,
                            month: e.target.value
                              ? Number(e.target.value.split("-")[1])
                              : null,
                          },
                          () => {
                            this.Get();
                          },
                        );
                      }}
                      value={
                        year
                          ? format_date(
                              new Date(year, month - 1),
                              "yyyy-mm",
                              "en",
                            )
                          : ""
                      }
                    />
                  )}
                {!["view", "print"].includes(type) && (
                  <button
                    className="btn btn-success px-4 me-2 mb-3"
                    onClick={async () => {
                      this.setState({ modal_create: true });
                    }}
                  >
                    สร้างเงินสดย่อยใหม่
                  </button>
                )}
              </div>
              {/* รายการ */}
              <div className="min-vh-100">
                {data_petty_cash
                  ?.sort((a, b) => {
                    const s = a.status?.localeCompare(b.status);
                    return s !== 0 ? s : a.time - b.time;
                  })
                  .map((item, index) => (
                    <div
                      className={
                        "rounded border-0 mb-3" +
                        (item.status === "cancel" ? " bg-secondaey-light" : "")
                      }
                      key={index}
                      style={{ opacity: item.status === "cancel" ? 0.6 : 1 }}
                    >
                      <div className="p-3">
                        <div className="d-flex align-items-center">
                          <h3 className="fw-bold">
                            {stripJuristic(item.project_name)}{" "}
                            {format_date(
                              new Date(item.year, item.month - 1),
                              "mmmm yyyy",
                              "th",
                            )}{" "}
                            (ครั้งที่ {item.time})
                          </h3>
                          <div className="ms-3">
                            {item.status === "cancel" &&
                              Status("ยกเลิก", "danger")}
                          </div>
                        </div>
                        <div>
                          <table className="table table-bordered mb-0">
                            <thead className="bg-light text-secondary">
                              <tr>
                                <th
                                  colSpan={3}
                                  className="text-nowrap text-center"
                                >
                                  ข้อมูลการใช้จ่ายเงินสดย่อย
                                </th>
                                <th
                                  colSpan={2}
                                  className="text-nowrap text-center"
                                >
                                  ใบสำคัญ
                                </th>
                                <th
                                  colSpan={
                                    1 +
                                    [1, 2, 3, 4, 5, 6].filter(
                                      (x) =>
                                        data_petty_cash[index][
                                          "expenses_type_label_" + x
                                        ],
                                    ).length
                                  }
                                  className="text-nowrap text-center py-0 align-middle"
                                >
                                  <div className="d-flex align-items-center justify-content-between">
                                    ประเภทการจ่าย
                                    {!data_petty_cash[index]
                                      .expenses_type_label_6 && (
                                      <button
                                        class="btn btn-sm btn-warning px-4 ms-2"
                                        onClick={() => {
                                          let _index = 0;
                                          [1, 2, 3, 4, 5].forEach((x, i) => {
                                            if (
                                              data_petty_cash[index][
                                                "expenses_type_label_" + x
                                              ]
                                            ) {
                                              _index = x;
                                            }
                                          });
                                          this.setState({
                                            modal_create_update_expenses: true,
                                            expenses_index: _index + 1,
                                            expenses_no: index,
                                            expenses_name: "",
                                          });
                                        }}
                                      >
                                        เพิ่ม
                                      </button>
                                    )}
                                  </div>
                                </th>
                                <th className="text-nowrap text-center">
                                  เงินสดย่อย
                                </th>
                                <th className="text-nowrap text-center wpx-100">
                                  สถานะ
                                </th>
                                <th
                                  colSpan={3}
                                  className="text-nowrap text-center"
                                >
                                  หมายเหตุ
                                </th>
                                <th className="text-nowrap text-center">ลบ</th>
                              </tr>
                              <tr>
                                <th className="text-nowrap text-center">
                                  ลำดับ
                                </th>
                                <th className="text-nowrap text-center wpx-120">
                                  วันที่
                                </th>
                                <th className="text-nowrap">
                                  รายการค่าใช้จ่าย
                                </th>
                                <th className="text-nowrap text-center wpx-120">
                                  เล่มที่
                                </th>
                                <th className="text-nowrap text-center wpx-120">
                                  เลขที่
                                </th>
                                {[1, 2, 3, 4, 5, 6].map(
                                  (x, i) =>
                                    typeof item["expenses_type_label_" + x] === "string" && item["expenses_type_label_" + x] && (
                                      <th className="text-nowrap text-center align-middle">
                                        <div className="d-flex align-items-center">
                                          {item["expenses_type_label_" + x] || "-"}
                                          {item[
                                            "expenses_type_center_" + x
                                          ] && (
                                            <small className="text-warning ms-2 text-8">
                                              (
                                              {data_expense_type?.find(
                                                (et) =>
                                                  et.value ===
                                                  item[
                                                    "expenses_type_center_" + x
                                                  ],
                                              )?.label || "-"}
                                              )
                                            </small>
                                          )}
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="white"
                                              id="dropdown-basic"
                                              size="sm"
                                              className="hpx-20 d-flex align-items-center justify-content-center ms-2 p-0"
                                            >
                                              <span className="icon pointer text-24 text-white">
                                                {"\uf107"}
                                              </span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                              <Dropdown.Item
                                                className="rounded-3 d-flex align-items-center px-2"
                                                onClick={() => {
                                                  this.setState({
                                                    modal_create_update_expenses: true,
                                                    expenses_index: x,
                                                    expenses_no: index,
                                                    expenses_name:
                                                      item[
                                                        "expenses_type_label_" +
                                                          x
                                                      ],
                                                  });
                                                }}
                                              >
                                                <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                  {"\uf044"}
                                                </div>{" "}
                                                แก้ไข
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                className="rounded-3 d-flex align-items-center px-2"
                                                onClick={() => {
                                                  this.setState({
                                                    index_data_petty_cash:
                                                      index,
                                                    index_expenses: x,
                                                    modal_expenses: true,
                                                    expenses_type_center:
                                                      item?.expenses_type_center_1,
                                                  });
                                                }}
                                              >
                                                <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                  {"\uf645"}
                                                </div>{" "}
                                                เพิ่มประเภทค่าใช้จ่ายกลาง
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                className="rounded-3 d-flex align-items-center px-2 text-danger"
                                                onClick={async () => {
                                                  if (
                                                    await alert(
                                                      "",
                                                      "warning",
                                                      "ยืนยัน",
                                                      "ยืนยันการลบประเภทการจ่ายนี้ใช่หรือไม่?",
                                                      "ลบข้อมูล",
                                                      "ยกเลิก",
                                                    )
                                                  ) {
                                                    const newData = [
                                                      ...data_petty_cash,
                                                    ];

                                                    newData[index] = {
                                                      ...newData[index],
                                                      ["expenses_type_label_" +
                                                      x]: "",
                                                      list_cash_spend: newData[
                                                        index
                                                      ]?.list_cash_spend?.map(
                                                        (obj) => ({
                                                          ...obj,
                                                          amount:
                                                            obj.amount.map(
                                                              (amt, idx) =>
                                                                idx === i
                                                                  ? {
                                                                      ...amt,
                                                                      amount:
                                                                        "",
                                                                    }
                                                                  : amt,
                                                            ),
                                                        }),
                                                      ),
                                                    };

                                                    this.setState({
                                                      data_petty_cash: newData,
                                                    });
                                                  }
                                                }}
                                              >
                                                <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                  {"\uf2ed"}
                                                </div>{" "}
                                                ลบ
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </th>
                                    ),
                                )}
                                <th className="text-nowrap text-center">
                                  ยอดรวม
                                </th>
                                <th className="text-nowrap text-center">
                                  คงเหลือ
                                </th>
                                <th className="text-nowrap"></th>
                                <th className="text-nowrap text-center">
                                  ใบเสร็จ
                                </th>
                                <th className="text-nowrap text-center">
                                  สำเนาบัตร
                                </th>
                                <th className="text-nowrap text-center wpx-80">
                                  รูปภาพสลิป
                                </th>
                                <th className="text-nowrap"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* วงเงิน เงินสดย่อยที่เบิกได้ */}
                              <tr>
                                <td className="bg-secondary-light"></td>
                                <td
                                  className={`bg-secondary-light ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <DatePicker
                                      type="th"
                                      className="rounded-0 form-control wpx-120"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].limit_withdraw.date = e;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.limit_withdraw.date}
                                    />
                                  ) : (
                                    format_date(item?.limit_withdraw.date)
                                  )}
                                </td>
                                <td className="bg-secondary-light text-nowrap">
                                  {item?.limit_withdraw.name}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เล่มที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].limit_withdraw.volumn_no =
                                          e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.limit_withdraw?.volumn_no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    item?.limit_withdraw?.volumn_no
                                  )}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เลขที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].limit_withdraw.no = e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.limit_withdraw.no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    item?.limit_withdraw.no
                                  )}
                                </td>
                                {[1, 2, 3, 4, 5, 6].map(
                                  (x, i) =>
                                    typeof item["expenses_type_label_" + x] === "string" && item["expenses_type_label_" + x] && (
                                      <th className="bg-secondary-light"></th>
                                    ),
                                )}
                                <td className="bg-secondary-light"></td>
                                <td
                                  className={`bg-secondary-light text-end ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <NumericFormat
                                      thousandSeparator=","
                                      decimalScale={2}
                                      getInputRef={(el) =>
                                        (this.inputRefs[
                                          `amount_000_${cash_index}`
                                        ] = el)
                                      }
                                      type="text"
                                      className="rounded-0 form-control w-100 text-end enter"
                                      placeholder="คงเหลือ"
                                      value={item?.limit_withdraw.amount}
                                      onValueChange={(e) => {
                                        for (let _item of data_petty_cash) {
                                          _item.limit_withdraw.amount = e.value;
                                        }
                                        data_petty_cash[
                                          index
                                        ].cash_withdraw.amount =
                                          Number(item.limit_withdraw.amount) -
                                          Number(item.previuse_balance.amount);
                                        this.setState({ data_petty_cash }, () =>
                                          this.calculatePrice(),
                                        );
                                      }}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(item?.limit_withdraw.amount)
                                  )}
                                </td>
                                {[0, 0, 0, 0, 0].map((e) => (
                                  <th className="bg-secondary-light"></th>
                                ))}
                              </tr>
                              {/* เงินสดย่อยคงเหลือที่ยกมา ครั้งก่อน */}
                              <tr>
                                <td className="bg-secondary-light"></td>
                                <td
                                  className={`bg-secondary-light ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <DatePicker
                                      type="th"
                                      className="rounded-0 form-control wpx-120"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].previuse_balance.date = e;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.previuse_balance.date}
                                    />
                                  ) : (
                                    format_date(item?.previuse_balance.date)
                                  )}
                                </td>
                                <td className="bg-secondary-light text-nowrap">
                                  {item?.previuse_balance.name}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เล่มที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].previuse_balance.volumn_no =
                                          e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.previuse_balance?.volumn_no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(
                                      item?.previuse_balance?.volumn_no || 0,
                                    )
                                  )}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เลขที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].previuse_balance.no = e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.previuse_balance.no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(item?.previuse_balance.no)
                                  )}
                                </td>
                                {[1, 2, 3, 4, 5, 6].map(
                                  (x, i) =>
                                    item["expenses_type_label_" + x] && (
                                      <th className="bg-secondary-light"></th>
                                    ),
                                )}
                                <td className="bg-secondary-light"></td>
                                <td
                                  className={`bg-secondary-light text-end ${
                                    data.filter((e) => e.status !== "cancel")
                                      .length === 0 && index === 0
                                      ? "p-0"
                                      : ""
                                  }`}
                                  title="ยกมาจากเดือนก่อน"
                                >
                                  {data.filter((e) => e.status !== "cancel")
                                    .length === 0 && index === 0 ? (
                                    <NumericFormat
                                      thousandSeparator=","
                                      decimalScale={2}
                                      getInputRef={(el) =>
                                        (this.inputRefs[
                                          `amount_00_${cash_index}`
                                        ] = el)
                                      }
                                      type="text"
                                      className="rounded-0 form-control w-100 text-end enter"
                                      placeholder="คงเหลือ"
                                      value={item?.previuse_balance.amount}
                                      onValueChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].previuse_balance.amount = e.value;
                                        data_petty_cash[
                                          index
                                        ].cash_withdraw.amount =
                                          Number(item.limit_withdraw.amount) -
                                          Number(item.previuse_balance.amount);
                                        this.setState({ data_petty_cash }, () =>
                                          this.calculatePrice(),
                                        );
                                      }}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(item?.previuse_balance.amount)
                                  )}
                                </td>
                                {[0, 0, 0, 0, 0].map((e) => (
                                  <th className="bg-secondary-light"></th>
                                ))}
                              </tr>
                              {/* เงินสดย่อยที่เบิกมา ครั้งนี้ */}
                              <tr>
                                <td className="bg-secondary-light"></td>
                                <td
                                  className={`bg-secondary-light ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <DatePicker
                                      type="th"
                                      className="rounded-0 form-control wpx-120"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].cash_withdraw.date = e;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.cash_withdraw.date}
                                    />
                                  ) : (
                                    format_date(item?.cash_withdraw.date)
                                  )}
                                </td>
                                <td className="bg-secondary-light text-nowrap">
                                  {item?.cash_withdraw.name}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เล่มที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].cash_withdraw.volumn_no =
                                          e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.cash_withdraw?.volumn_no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(item?.cash_withdraw?.volumn_no || 0)
                                  )}
                                </td>
                                <td
                                  className={`bg-secondary-light text-center ${!["view", "print"].includes(type) ? "p-0" : ""}`}
                                >
                                  {!["view", "print"].includes(type) ? (
                                    <input
                                      type="text"
                                      className="rounded-0 form-control wpx-120 enter"
                                      placeholder="เลขที่"
                                      onChange={(e) => {
                                        data_petty_cash[
                                          index
                                        ].cash_withdraw.no = e.target.value;
                                        this.setState({ data_petty_cash });
                                      }}
                                      value={item?.cash_withdraw.no}
                                      onKeyDown={(e) =>
                                        this.handleEnterAuto(e, index)
                                      }
                                    />
                                  ) : (
                                    toFixed(item?.cash_withdraw.no)
                                  )}
                                </td>
                                {[1, 2, 3, 4, 5, 6].map(
                                  (x, i) =>
                                    item["expenses_type_label_" + x] && (
                                      <th className="bg-secondary-light"></th>
                                    ),
                                )}
                                <td className="bg-secondary-light"></td>
                                <td
                                  className="bg-secondary-light text-end"
                                  title="นำค่า 2 ค่ามาลบกัน (วงเงิน เงินสดย่อยที่เบิกได้ - เงินสดย่อยคงเหลือที่ยกมา ครั้งก่อน)"
                                >
                                  {toFixed(item?.cash_withdraw.amount)}
                                </td>
                                {[0, 0, 0, 0, 0].map((e) => (
                                  <th className="bg-secondary-light"></th>
                                ))}
                              </tr>
                              {item?.list_cash_spend?.map(
                                (cash_item, cash_index) =>
                                  !["view", "print"].includes(type) ? (
                                    <tr>
                                      <td className="text-center">
                                        {cash_index + 1}
                                      </td>
                                      <td className="p-0">
                                        <DatePicker
                                          type="th"
                                          className="rounded-0 form-control wpx-120"
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[cash_index].date =
                                              e;
                                            this.setState(
                                              { data_petty_cash },
                                              () => this.calculatePrice(),
                                            );
                                          }}
                                          value={cash_item.date}
                                        />
                                      </td>
                                      <td className="text-nowrap p-0">
                                        <input
                                          type="text"
                                          className="rounded-0 form-control w-100 enter"
                                          placeholder="รายการค่าใช้จ่าย"
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[cash_index].name =
                                              e.target.value;
                                            this.setState(
                                              { data_petty_cash },
                                              () => this.calculatePrice(),
                                            );
                                          }}
                                          value={cash_item.name}
                                          onKeyDown={(e) =>
                                            this.handleEnterAuto(e, index)
                                          }
                                        />
                                      </td>
                                      <td className="text-center p-0">
                                        <input
                                          type="text"
                                          className="rounded-0 form-control wpx-120 enter"
                                          placeholder="เล่มที่"
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[
                                              cash_index
                                            ].volumn_no = e.target.value;
                                            this.setState(
                                              { data_petty_cash },
                                              () => this.calculatePrice(),
                                            );
                                          }}
                                          value={cash_item?.volumn_no}
                                          onKeyDown={(e) =>
                                            this.handleEnterAuto(e, index)
                                          }
                                        />
                                      </td>
                                      <td className="text-center p-0">
                                        <input
                                          type="text"
                                          className="rounded-0 form-control wpx-120 enter"
                                          placeholder="เลขที่"
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[cash_index].no =
                                              e.target.value;
                                            this.setState(
                                              { data_petty_cash },
                                              () => this.calculatePrice(),
                                            );
                                          }}
                                          value={cash_item.no}
                                          onKeyDown={(e) =>
                                            this.handleEnterAuto(e, index)
                                          }
                                        />
                                      </td>
                                      {[1, 2, 3, 4, 5, 6].map(
                                        (x, i) =>
                                          item["expenses_type_label_" + x] && (
                                            <td className="text-end p-0">
                                              <NumericFormat
                                                thousandSeparator=","
                                                decimalScale={2}
                                                getInputRef={(el) =>
                                                  (this.inputRefs[
                                                    `amount_${index}_${cash_index}`
                                                  ] = el)
                                                }
                                                type="text"
                                                className="rounded-0 form-control w-100 text-end enter"
                                                placeholder={
                                                  item[
                                                    "expenses_type_label_" + x
                                                  ]
                                                }
                                                value={
                                                  cash_item.amount[i]?.amount
                                                }
                                                onValueChange={(e) => {
                                                  data_petty_cash[
                                                    index
                                                  ].list_cash_spend[
                                                    cash_index
                                                  ].amount[i].amount = e.value;
                                                  this.setState(
                                                    { data_petty_cash },
                                                    () => this.calculatePrice(),
                                                  );
                                                }}
                                                onKeyDown={(e) =>
                                                  this.handleEnterAuto(e, index)
                                                }
                                              />
                                            </td>
                                          ),
                                      )}
                                      <td className="text-end">
                                        {toFixed(
                                          total(cash_item.amount, "amount"),
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {toFixed(
                                          this.cal(index, cash_index) || 0,
                                        )}
                                      </td>
                                      <td className="text-nowrap text-center p-0">
                                        <select
                                          className={`form-control w-100 rounded-0 border-0 wpx-100 text-center ${
                                            status[cash_item?.status]?.style
                                          }`}
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[
                                              cash_index
                                            ].status = e.target.value;
                                            this.setState({ data_petty_cash });
                                          }}
                                          value={cash_item?.status}
                                          disabled={
                                            ![
                                              "super_user",
                                              "admin",
                                              "accounting",
                                            ].includes(profile?.user_type) &&
                                            !["fix", "fixed"].includes(
                                              cash_item?.status,
                                            )
                                          }
                                        >
                                          {Object.keys(status).map((e) => (
                                            <option
                                              value={e}
                                              disabled={
                                                !status[e].role.includes(profile?.user_type)
                                              }
                                            >
                                              {status[e].name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td className="text-center text-success px-1 py-0">
                                        <Switch
                                          className="mt-2"
                                          offColor="#dfdfdf"
                                          height={20}
                                          width={40}
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[
                                              cash_index
                                            ].receipt = e;
                                            this.setState({ data_petty_cash });
                                          }}
                                          checked={cash_item.receipt}
                                        />
                                      </td>
                                      <td className="text-center text-danger px-1 py-0">
                                        <Switch
                                          className="mt-2"
                                          offColor="#dfdfdf"
                                          height={20}
                                          width={40}
                                          onChange={(e) => {
                                            data_petty_cash[
                                              index
                                            ].list_cash_spend[
                                              cash_index
                                            ].copy_id_card = e;
                                            this.setState({ data_petty_cash });
                                          }}
                                          checked={cash_item.copy_id_card}
                                        />
                                      </td>
                                      <td className="py-1 text-center">
                                        <div className="d-flex justify-content-center">
                                          {cash_item.image_slip.map((e, i) => (
                                            <img
                                              className="wpx-25 hpx-25 rounded-3 img-fluid mx-1 pointer"
                                              src={e}
                                              alt="slip"
                                              onClick={async () => {
                                                this.setState({
                                                  modal_detail: true,
                                                  slip_image: e,
                                                  time_index: index,
                                                  cash_index: cash_index,
                                                  image_index: i,
                                                });
                                              }}
                                            />
                                          ))}
                                          {cash_item.image_slip.length !==
                                            2 && (
                                            <div
                                              className="icon text-14 mx-1 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-primary-light text-primary"
                                              onClick={async () => {
                                                document
                                                  .getElementById("image_slip")
                                                  .click();
                                                this.setState({
                                                  time_index: index,
                                                  cash_index: cash_index,
                                                });
                                              }}
                                            >
                                              {"\uf03e"}
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                      <td className="py-1">
                                        <div className="d-flex justify-content-center">
                                          {/* DELETE */}
                                          {(cash_item?.status === "pending" ||
                                            profile?.user_type ===
                                              "super_user") && (
                                            <BtnIcon
                                              type="delete"
                                              onClick={async () => {
                                                if (
                                                  await alert(
                                                    "",
                                                    "warning",
                                                    "ลบรายการ",
                                                    "คุณต้องการลบรายการนี้หรือไม่?",
                                                    "ยืนยัน",
                                                    "ยกเลิก",
                                                  )
                                                ) {
                                                  data_petty_cash[
                                                    index
                                                  ].list_cash_spend.splice(
                                                    cash_index,
                                                    1,
                                                  );
                                                  this.setState(
                                                    { data_petty_cash },
                                                    () => this.calculatePrice(),
                                                  );
                                                }
                                              }}
                                            />
                                          )}
                                          {/* ถ้าไม่มีรูปแสดงเป็นสีแดง */}
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <td className="text-center">
                                        {cash_index + 1}
                                      </td>
                                      <td>{format_date(cash_item?.date)}</td>
                                      <td className="text-nowrap">
                                        {cash_item?.name}
                                      </td>
                                      <td className="text-center">
                                        {cash_item?.volumn_no}
                                      </td>
                                      <td className="text-center">
                                        {cash_item?.no}
                                      </td>
                                      {[1, 2, 3, 4, 5, 6].map(e=>
                                        item["expenses_type_label_" + e] && (
                                          <td className="text-end">
                                            {toFixed(cash_item?.amount[e-1]?.amount)}
                                          </td>
                                        ))}
                                      <td className="text-end">
                                        {toFixed(
                                          total(cash_item?.amount, "amount"),
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {toFixed(
                                          this.cal(index, cash_index) || 0,
                                        )}
                                      </td>
                                      <td
                                        className={`text-nowrap text-center p-0 ${
                                          status[cash_item?.status]?.style
                                        }`}
                                      >
                                        {!["view", "print"].includes(type) ? (
                                          <select
                                            className={`form-control w-100 rounded-0 border-0 wpx-100 text-center ${
                                              status[cash_item?.status]?.style
                                            }`}
                                            onChange={(e) => {
                                              data.list_cash_spend[
                                                cash_index
                                              ].status = e.target.value;
                                              this.setState({ data });
                                            }}
                                            value={cash_item?.status}
                                          >
                                            {Object.keys(status).map((e) => (
                                              <option value={e}>
                                                {status[e].name}
                                              </option>
                                            ))}
                                          </select>
                                        ) : (
                                          status[cash_item?.status].name
                                        )}
                                      </td>
                                      <td className="text-center text-success px-1 py-0">
                                        <Switch
                                          className="mt-2"
                                          offColor="#dfdfdf"
                                          height={20}
                                          width={40}
                                          disabled
                                          onChange={(e) => {
                                            data.list_cash_spend[
                                              cash_index
                                            ].receipt = e;
                                            this.setState({ data });
                                          }}
                                          checked={cash_item.receipt}
                                        />
                                      </td>
                                      <td className="text-center text-danger px-1 py-0">
                                        <Switch
                                          className="mt-2"
                                          offColor="#dfdfdf"
                                          height={20}
                                          width={40}
                                          disabled
                                          onChange={(e) => {
                                            data.list_cash_spend[
                                              cash_index
                                            ].copy_id_card = e;
                                            this.setState({ data });
                                          }}
                                          checked={cash_item.copy_id_card}
                                        />
                                      </td>
                                      <td className="py-1 text-center">
                                        <div className="d-flex justify-content-center">
                                          {cash_item.image_slip.map((e) => (
                                            <img
                                              className="wpx-25 hpx-25 rounded-3 img-fluid mx-1 pointer"
                                              src={e}
                                              alt="slip"
                                              onClick={async () => {
                                                this.setState({
                                                  modal_detail: true,
                                                  slip_image:
                                                    cash_item.image_slip,
                                                  slip_index: index,
                                                  select_image:
                                                    cash_item.image_slip[0],
                                                });
                                              }}
                                            />
                                          ))}
                                        </div>
                                      </td>
                                      <td className="py-1"></td>
                                    </tr>
                                  ),
                              )}
                              <tr>
                                <td colSpan={5}>รวมทั้งสิ้น</td>
                                {[1, 2, 3, 4, 5, 6].map(
                                  (x, i) =>
                                    item["expenses_type_label_" + x] && (
                                      <td className="text-end fw-bold">
                                        {toFixed(this.calTotal(index, i) || 0)}
                                      </td>
                                    ),
                                )}
                                <td className="text-end fw-bold">
                                  {toFixed(
                                    total(
                                      item?.list_cash_spend?.map((d) =>
                                        total(d.amount, "amount"),
                                      ),
                                    ),
                                  )}
                                </td>
                                <td
                                  className={`text-end fw-bold ${
                                    Number(item.limit_withdraw.amount) -
                                      total(
                                        item?.list_cash_spend?.map((e) =>
                                          total(e.amount, "amount"),
                                        ),
                                      ) <
                                    0
                                      ? "text-danger"
                                      : ""
                                  }`}
                                >
                                  {toFixed(
                                    Number(item.limit_withdraw.amount) -
                                      total(
                                        item?.list_cash_spend?.map((e) =>
                                          total(e.amount, "amount"),
                                        ),
                                      ),
                                  )}
                                </td>
                                <td className="text-end"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              {total(
                                item?.list_cash_spend
                                  ?.filter((e) => e.status === "fix")
                                  ?.map((d) => total(d.amount, "amount")),
                              ) > 0 && (
                                <tr>
                                  <td
                                    className="bg-danger-light text-end"
                                    colSpan={10}
                                  >
                                    ยอดที่ไม่ผ่านการอนุมัติ
                                  </td>
                                  <td className="bg-danger text-white text-end">
                                    {toFixed(
                                      total(
                                        item?.list_cash_spend
                                          .filter((e) => e.status === "fix")
                                          .map((d) =>
                                            total(d.amount, "amount"),
                                          ),
                                      ),
                                    )}
                                  </td>
                                  <td
                                    className="bg-danger-light"
                                    colSpan={6}
                                  ></td>
                                </tr>
                              )}
                              {!["view", "print"].includes(type) && (
                                <tr>
                                  <td
                                    className="bg-success-light pointer"
                                    colSpan={18}
                                    onClick={async () => {
                                      data_petty_cash[
                                        index
                                      ].list_cash_spend.push({
                                        date: "",
                                        name: "",
                                        volumn_no: "",
                                        no: "",
                                        amount: [
                                          {
                                            name: item?.expenses_type_label_1,
                                            amount: "",
                                          },
                                          {
                                            name: item?.expenses_type_label_2,
                                            amount: "",
                                          },
                                          {
                                            name: item?.expenses_type_label_3,
                                            amount: "",
                                          },
                                          {
                                            name: item?.expenses_type_label_4,
                                            amount: "",
                                          },
                                          {
                                            name: item?.expenses_type_label_5,
                                            amount: "",
                                          },
                                          {
                                            name: item?.expenses_type_label_6,
                                            amount: "",
                                          },
                                        ],
                                        status: "pending",
                                        receipt: false,
                                        copy_id_card: false,
                                        image_slip: [],
                                      });
                                      this.setState({ data_petty_cash });
                                    }}
                                  >
                                    <span className="icon text-primary me-2">
                                      {"\uf055"}
                                    </span>
                                    เพิ่มรายการ
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <input
                            hidden
                            accept="image/*"
                            id="image_slip"
                            type="file"
                            onChange={async (e) => {
                              let image = await new Promise((resolve) => {
                                Resizer.imageFileResizer(
                                  e.target.files[0],
                                  1200,
                                  1200,
                                  "JPEG",
                                  100,
                                  0,
                                  (uri) => {
                                    resolve(uri);
                                  },
                                  "base64",
                                );
                              });
                              data_petty_cash[time_index].list_cash_spend[
                                cash_index
                              ].image_slip.push(image);
                              this.setState({ data_petty_cash });
                              e.target.value = "";
                              e.target.files = null;
                            }}
                          />
                        </div>
                        <div className="mt-3">
                          <div className="d-flex justify-content-end">
                            <div>ค่าใช้จ่ายรวมทั้งสิ้น</div>
                            <h4 className="fw-bold wpx-150 text-danger mb-0 text-end">
                              {toFixed(
                                total(
                                  item?.list_cash_spend?.map((d) =>
                                    total(d.amount, "amount"),
                                  ),
                                ),
                              )}
                            </h4>
                          </div>
                          <div className="d-flex justify-content-end">
                            <div>ยอดเงินสดย่อยคงเหลือทั้งสิ้น</div>
                            <h4
                              className={`fw-bold wpx-150 mb-0 text-end ${
                                Number(item.limit_withdraw.amount) -
                                  total(
                                    item?.list_cash_spend?.map((e) =>
                                      total(e.amount, "amount"),
                                    ),
                                  ) <
                                0
                                  ? "text-danger"
                                  : "text-success"
                              }`}
                            >
                              {toFixed(
                                Number(item.limit_withdraw.amount) -
                                  total(
                                    item?.list_cash_spend?.map((e) =>
                                      total(e.amount, "amount"),
                                    ),
                                  ),
                              )}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="hpx-400"></div>
              </div>
              {type !== "view" && (
                <div
                  className="position-fixed w-100 bg-white px-3 py-2 d-flex justify-content-end"
                  style={{ bottom: 0, left: 0 }}
                >
                  {type === "print" && (
                    <div className="d-flex">
                      <button
                        className="btn btn-success ms-2 px-4"
                        onClick={() => {
                          this.printPDF("table");
                        }}
                      >
                        พิมพ์ตาราง
                      </button>
                      <button
                        className="btn btn-success ms-2 px-4"
                        onClick={() => {
                          this.printPDF("full");
                        }}
                      >
                        พิมพ์รายละเอียด
                      </button>
                    </div>
                  )}
                  {!["view", "print"].includes(type) && (
                    <div>
                      {data_petty_cash.length !== 0 &&
                        data_petty_cash.every((p) =>
                          p.list_cash_spend.every(
                            (e) => e.status === "approved",
                          ),
                        ) && (
                          <button
                            className="btn btn-primary px-4 me-2"
                            onClick={async () => {
                              this.CreateUpdate("approved");
                            }}
                          >
                            อนุมัติ
                          </button>
                        )}
                      <button
                        className="btn btn-success px-4"
                        onClick={async () => {
                          if (_status !== "approved") {
                            this.CreateUpdate("pending");
                          } else {
                            this.CreateUpdate("approved");
                          }
                        }}
                      >
                        บันทึก
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* รายการ */}
          {tab_menu === "รายการ" && (
            <div>
              <div className="d-flex align-items-center flex-wrap">
                <input
                  type="text"
                  className="form-control wpx-250 me-2 mb-2"
                  placeholder="ค้นหา..."
                  onChange={(e) => {
                    this.setState({ filter_search: e.target.value });
                  }}
                  value={filter_search}
                />
                <div className="d-flex">
                  <button
                    className="btn btn-success px-4 me-2 mb-2"
                    onClick={() => {
                      this.Get(1);
                    }}
                  >
                    ค้นหา
                  </button>
                  <button
                    className="btn btn-outline-success px-4 me-2 mb-2"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    ล้างค่า
                  </button>
                </div>
              </div>
              <div className="card rounded border-0 overflow-hidden">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="bg-light text-secondary">
                      <tr>
                        <th className="wpx-50 text-center">ลำดับ</th>
                        <th>เดือน/ปี</th>
                        <th className="wpx-150">สถานะ</th>
                        <th className="text-center wpx-90">จัดการ</th>
                      </tr>
                    </thead>
                    {data?.map((item, index) => (
                      <tbody>
                        <tr
                          key={"table_" + index}
                          className="pointer"
                          onClick={() => {
                            data[index].show = !item.show;
                            this.setState({ data });
                          }}
                        >
                          <td className="text-center">{index + 1}</td>
                          <td>{format_date(item.yearMonth, "mmmm yyyy")}</td>
                          <td>
                            {Status(
                              {
                                pending: "รออนุมัติ",
                                approved: "อนุมัติ",
                                cancel: "ยกเลิก",
                              }[
                                item.items.every((e) => e.status === "pending")
                                  ? "pending"
                                  : item.items.every(
                                        (e) => e.status === "approved",
                                      )
                                    ? "approved"
                                    : item.items.every(
                                          (e) => e.status === "cancel",
                                        )
                                      ? "cancel"
                                      : "pending"
                              ],
                              {
                                pending: "warning",
                                approved: "success",
                                cancel: "danger",
                              }[
                                item.items.every((e) => e.status === "pending")
                                  ? "pending"
                                  : item.items.every(
                                        (e) => e.status === "approved",
                                      )
                                    ? "approved"
                                    : item.items.every(
                                          (e) => e.status === "cancel",
                                        )
                                      ? "cancel"
                                      : "pending"
                              ],
                            )}
                          </td>
                          <td className="py-1">
                            <div className="d-flex justify-content-center">
                              <BtnIcon
                                type="csv"
                                onClick={async () => {
                                  await this.GetByID(item.year, item.month);
                                  this.exportExcel();
                                }}
                              />
                              <BtnIcon
                                type="print"
                                onClick={async () => {
                                  this.setState({
                                    type: "print",
                                    tab_menu: "สร้าง",
                                  });
                                  this.GetByID(item.year, item.month);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                        {item.show &&
                          item.items
                            .sort((a, b) => {
                              const s = a.status?.localeCompare(b.status);
                              return s !== 0 ? s : a.time - b.time;
                            })
                            .map((child, child_index) => (
                              <tr key={"table_" + index}>
                                <td className="text-center bg-secondary-light"></td>
                                <td className="bg-secondary-light">
                                  {format_date(item.yearMonth, "mmmm yyyy")}{" "}
                                  ครั้งที่ {child.time}
                                </td>
                                <td className="bg-secondary-light">
                                  {Status(
                                    {
                                      pending: "รออนุมัติ",
                                      approved: "อนุมัติ",
                                      cancel: "ยกเลิก",
                                    }[child.status],
                                    {
                                      pending: "warning",
                                      approved: "success",
                                      cancel: "danger",
                                    }[child.status],
                                  )}
                                </td>
                                <td className="py-1 bg-secondary-light">
                                  <div className="d-flex justify-content-center">
                                    {/* VIEW */}
                                    {child.status !== "cancel" && (
                                      <BtnIcon
                                        type="update"
                                        onClick={async () => {
                                          this.setState({
                                            type: "update",
                                            tab_menu: "สร้าง",
                                          });
                                          this.GetByID(item.year, item.month);
                                        }}
                                      />
                                    )}
                                    {child.status !== "pending" && (
                                      <BtnIcon
                                        type="view"
                                        onClick={() => {
                                          this.setState({
                                            type: "view",
                                            tab_menu: "สร้าง",
                                          });
                                          this.GetByID(item.year, item.month);
                                        }}
                                      />
                                    )}
                                    {/* DELETE */}
                                    {data.find(
                                      (_item) =>
                                        (_item.items.every(
                                          (e) => e.status === "pending",
                                        )
                                          ? "pending"
                                          : _item.items.every(
                                                (e) => e.status === "approved",
                                              )
                                            ? "approved"
                                            : _item.items.every(
                                                  (e) => e.status === "cancel",
                                                )
                                              ? "cancel"
                                              : "") !== "cancel",
                                    )?.year === item?.year &&
                                      data.find(
                                        (_item) =>
                                          (_item.items.every(
                                            (e) => e.status === "pending",
                                          )
                                            ? "pending"
                                            : _item.items.every(
                                                  (e) =>
                                                    e.status === "approved",
                                                )
                                              ? "approved"
                                              : _item.items.every(
                                                    (e) =>
                                                      e.status === "cancel",
                                                  )
                                                ? "cancel"
                                                : "") !== "cancel",
                                      )?.month === item.month &&
                                      child.status !== "cancel" && (
                                        <BtnIcon
                                          type="delete"
                                          onClick={() => {
                                            this.Delete(child.petty_cash_id);
                                          }}
                                        />
                                      )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-between p-3">
                <small>ทั้งหมด {this.state.count} รายการ</small>
                <Pagination
                  count={Math.ceil(this.state.count / 10)}
                  showFirstButton
                  showLastButton
                  onChange={(_, page) => {
                    this.Get(page);
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {/* CREATE */}
        <Modal
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">สร้างเงินสดย่อยใหม่</h5>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex mb-2">
              <div className="wpx-120 mt-2">เดือน</div>
              <div className="wpx-120 mt-2">
                {format_date(new Date(year, month - 1), "mmmm yyyy")}
              </div>
            </div>
            <div className="d-flex mb-2">
              <div className="wpx-120 mt-2">ครั้งที่</div>
              <div className="wpx-120 mt-2">{data_petty_cash.length + 1}</div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  const _data = {
                    project_id: project?.project_id, // รหัสโครงการ
                    project_name: project?.project_name, // ชื่อโครงการ
                    month: month, // เดือน
                    year: year, // เดือน
                    time:
                      data_petty_cash.filter(
                        (e) => e.month === month && e.year === year,
                      ).length + 1, // ครั้งที่
                    limit_withdraw: {
                      date: "",
                      name: "วงเงิน เงินสดย่อยที่เบิกได้",
                      volumn_no: "",
                      no: "",
                      amount:
                        data_petty_cash[0]?.limit_withdraw?.amount ||
                        prev_month_limit_withdraw ||
                        "",
                    }, // วงเงิน เงินสดย่อยที่เบิกได้
                    previuse_balance: {
                      date: "",
                      name: "เงินสดย่อยคงเหลือที่ยกมา ครั้งก่อน",
                      volumn_no: "",
                      no: "",
                      amount: prev_month_previuse_balance || "",
                    }, // เงินสดย่อยคงเหลือที่ยกมา ครั้งก่อน
                    cash_withdraw: {
                      date: "",
                      name: "เงินสดย่อยที่เบิกมา ครั้งนี้",
                      volumn_no: "",
                      no: "",
                      amount: "",
                    }, // เงินสดย่อยที่เบิกมา ครั้งนี้
                    list_cash_spend: [],
                    expenses_type_label_1:
                      data_petty_cash[0]?.expenses_type_label_1 ||
                      prev_expenses_type_label_1 ||
                      "",
                    expenses_type_label_2:
                      data_petty_cash[0]?.expenses_type_label_2 ||
                      prev_expenses_type_label_2 ||
                      "",
                    expenses_type_label_3:
                      data_petty_cash[0]?.expenses_type_label_3 ||
                      prev_expenses_type_label_3 ||
                      "",
                    expenses_type_label_4:
                      data_petty_cash[0]?.expenses_type_label_4 ||
                      prev_expenses_type_label_4 ||
                      "",
                    expenses_type_label_5:
                      data_petty_cash[0]?.expenses_type_label_5 ||
                      prev_expenses_type_label_5 ||
                      "",
                    expenses_type_label_6:
                      data_petty_cash[0]?.expenses_type_label_6 ||
                      prev_expenses_type_label_6 ||
                      "",
                    expenses_type_center_1:
                      data_petty_cash[0]?.expenses_type_center_1 ||
                      prev_expenses_type_center_1 ||
                      "",
                    expenses_type_center_2:
                      data_petty_cash[0]?.expenses_type_center_2 ||
                      prev_expenses_type_center_2 ||
                      "",
                    expenses_type_center_3:
                      data_petty_cash[0]?.expenses_type_center_3 ||
                      prev_expenses_type_center_3 ||
                      "",
                    expenses_type_center_4:
                      data_petty_cash[0]?.expenses_type_center_4 ||
                      prev_expenses_type_center_4 ||
                      "",
                    expenses_type_center_5:
                      data_petty_cash[0]?.expenses_type_center_5 ||
                      prev_expenses_type_center_5 ||
                      "",
                    expenses_type_center_6:
                      data_petty_cash[0]?.expenses_type_center_6 ||
                      prev_expenses_type_center_6 ||
                      "",
                    // status = pending, fix, fixed, approved
                  };
                  data_petty_cash.push(_data);
                  this.setState({ modal_create: false, data_petty_cash }, () =>
                    this.calculatePrice(),
                  );
                }}
              >
                เพิ่มรายการ
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* Create Update EXPENSES */}
        <Modal
          show={modal_create_update_expenses}
          onHide={() => this.setState({ modal_create_update_expenses: false })}
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">ประเภทค่าใช้จ่าย</h5>
          </Modal.Header>
          <Modal.Body>
            <input
              type="text"
              className="form-control"
              onChange={(e) => this.setState({ expenses_name: e.target.value })}
              value={expenses_name}
            />
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  if (!expenses_name) {
                    alert(
                      "",
                      "warning",
                      "แจ้งเตือน",
                      "กรุณากรอกประเภทค่าใช้จ่าย",
                    );
                    return;
                  }
                  let _data_petty_cash = data_petty_cash;
                  _data_petty_cash[expenses_no][
                    "expenses_type_label_" + expenses_index
                  ] = expenses_name;
                  this.setState({
                    data_petty_cash,
                    modal_create_update_expenses: false,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_create_update_expenses: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* EXPENSES */}
        <Modal
          show={modal_expenses}
          onHide={() => this.setState({ modal_expenses: false })}
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">
              เลือกค่าใช้จ่ายกลางสำหรับ ครั้งที่ {index_data_petty_cash + 1}{" "}
              {data_petty_cash[index_data_petty_cash]?.[
                "expenses_type_label_" + index_expenses
              ] || ""}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex mb-2">
              <div className="wpx-100 mt-2">ค่าใช้จ่ายกลาง</div>
              <select
                className="form-control"
                onChange={(e) => {
                  this.setState({ expenses_type_center: e.target.value });
                }}
                value={expenses_type_center}
              >
                <option value="">เลือกค่าใช้จ่ายกลาง</option>
                {data_expense_type.map((e) => (
                  <option value={e.value}>{e.label}</option>
                ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  let data = [...data_petty_cash];
                  data[index_data_petty_cash][
                    "expenses_type_center_" + index_expenses
                  ] = expenses_type_center;
                  this.setState({
                    modal_expenses: false,
                    data_petty_cash: data,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_expenses: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* EXPORT */}
        <Modal
          show={modal_export}
          onHide={() => this.setState({ modal_export: false })}
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">Export {type_export}</h5>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex mb-2">
              <div className="wpx-120 mt-2">เดือนเริ่มต้น</div>
              <input
                type="month"
                className="form-control"
                placeholder="กรอกข้อมูล..."
                min={new Date()}
                onChange={(e) => {
                  this.setState({ month: e.target.value });
                }}
                value={month}
              />
            </div>
            <div className="d-flex mb-2">
              <div className="wpx-120 mt-2">เดือนสิ้นสุด</div>
              <input
                type="month"
                className="form-control"
                placeholder="กรอกข้อมูล..."
                min={new Date()}
                onChange={(e) => {
                  this.setState({ month: e.target.value });
                }}
                value={month}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="w-100 d-flex">
              <button
                className="btn btn-danger w-100 me-1"
                onClick={() => {
                  this.setState({ modal_export: false });
                }}
              >
                ยกเลิก
              </button>
              <button
                className="btn btn-success w-100 ms-1"
                onClick={() => {
                  this.setState({ modal_export: false });
                }}
              >
                Export {type_export}
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* VIEW */}
        <Modal
          show={modal_detail}
          size="lg"
          className="rounded-3"
          onHide={() => {
            this.setState({ modal_detail: false });
          }}
        >
          <Modal.Body className="p-0 rounded-top-3">
            <div className="w-100 d-flex justify-content-center bg-secondary-light rounded-top-3">
              <img
                className="w-100 img-fluid rounded-top-3"
                src={slip_image}
                alt="slip"
                style={{ objectFit: "contain" }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between py-1">
            {!["view", "print"].includes(type) ? (
              <BtnIcon
                type="delete"
                onClick={async () => {
                  if (
                    await alert(
                      "",
                      "info",
                      "ยืนยัน",
                      "ยืนยันการลบข้อมูลนี้หรือไม่?",
                      "ลบข้อมูล",
                      "ยกเลิก",
                    )
                  ) {
                    data_petty_cash[time_index].list_cash_spend[
                      cash_index
                    ].image_slip.splice(image_index, 1);
                    this.setState({
                      data_petty_cash,
                      modal_detail: false,
                    });
                  }
                }}
              />
            ) : (
              <div />
            )}
            <button
              className="btn btn-outline-danger px-5"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              ปิดหน้าต่าง
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
